export enum ContactType {
  LocalAuthority = 4,
  Tenant = 10,
  Vendor = 12,
  Landlord = 13,
}
